import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(24);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const RedLoadTimeIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <mask
        id="redLoadTimeIcon"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#redLoadTimeIcon)">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path
          d="M12 0C14.3734 2.83022e-08 16.6935 0.703788 18.6668 2.02236C20.6402 3.34094 22.1783 5.21509 23.0866 7.4078C23.9948 9.60051 24.2324 12.0133 23.7694 14.3411C23.3064 16.6689 22.1635 18.8071 20.4853 20.4853C18.8071 22.1635 16.6689 23.3064 14.3411 23.7694C12.0133 24.2324 9.60051 23.9948 7.4078 23.0866C5.21509 22.1783 3.34094 20.6402 2.02236 18.6668C0.703788 16.6935 -5.66044e-08 14.3734 0 12H12V0Z"
          fill="#DC0032"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7477 11.0267C14.8667 11.0921 16 11.3089 16 11.9999C16 12.6914 14.8653 12.9101 13.7455 12.9769C13.4031 13.5874 12.7497 13.9999 12 13.9999C11.2109 13.9999 10.5285 13.5429 10.2031 12.8792C7.03255 12.6112 1 11.9999 1 11.9999C1 11.9999 7.02954 11.3922 10.2008 11.1256C10.5252 10.4592 11.209 9.99994 12 9.99994C12.7513 9.99994 13.4058 10.4142 13.7477 11.0267Z"
          fill="black"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(RedLoadTimeIcon);
